import { Users, Activity, Cpu, LogOut, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/logo.svg";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { logout as logoutAction } from "../../actions/authActions";

function Sidebar({ role, activePage, setActivePaeg, sidebarOpen, setSidebarOpen, forceOverlay = false }) {
    
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const isActive = (path) => {
        if (path === "/admin") {
            return location.pathname === "/admin";
        }

        if (path === "/user") {
            return location.pathname === "/user";
        }

        return location.pathname.startsWith(path);
    };

    const logout = () => {
        dispatch(logoutAction());
        navigate("/");
    }

    const adminItems = [
        {
            key: "live",
            label: "Live Monitor",
            icon: <Activity size={18} />,
            path: "/admin"
        },
        {
            key: "equipment",
            label: "Equipment",
            icon: <Cpu size={18} />,
            path: "/admin/equipment"
        },
        {
            key: "users",
            label: "Users",
            icon: <Users size={18} />,
            path: "/admin/users"
        }
    ];

    const userItems = [
        {
            key: "live",
            label: "Live Monitor",
            icon: <Activity size={18} />,
            path: "/user"
        }
    ]

    const items = role === "A" ? adminItems : userItems;

    const timeString = currentTime.toLocaleTimeString("en-GB", {
        hour12: false,
    });
    
    const dateString = currentTime.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
    });

    return (
        // <div className="fixed left-0 top-0 w-72 bg-deepNavy h-screen flex flex-col text-white">

        <div className={`
            fixed top-0 left-0 z-50 w-72 h-screen bg-deepNavy text-white flex flex-col transform transition-transform duration-300
            ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
            ${forceOverlay ? "" : "lg:translate-x-0"}
        `}>
            
            {/* Logo */}
            <div className="px-6 py-8 border-b border-white/10">
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-4">
                        <img 
                            src={Logo}
                            alt="LiveGrid"
                            className="h-12 w-12"
                        />

                        <div>
                            <h1 className="text-xl font-bold tracking-wide">
                                LIVEGRID
                            </h1>

                            <p className="text-xs text-slate-400">
                                Power Monitoring System
                            </p>
                        </div>
                    </div>

                    <button
                        className={forceOverlay ? "" : "lg:hidden"}
                        onClick={() => setSidebarOpen(false)}
                    >  
                        <X size={22} />
                    </button>
                </div>

                <div className="mt-6">
                    <div className="text-2xl lg:text-3xl font-bold tracking-wider text-white">
                        {timeString}
                    </div>

                    <div className="mt-1 text-xs lg:text-sm text-slate-400">
                        {dateString}
                    </div>
                </div>
            </div>

            {/* Nav */}
            <div className="flex-1 p-4 flex flex-col gap-2">
                <div className="px-4 pb-2">
                    <p className="text-xs uppercase tracking-[3px] text-slate-500">
                        Navigation
                    </p>
                </div>

                {items.map(item => (
                    <button
                        key={item.key}
                        onClick={() => {
                            navigate(item.path);
                            setSidebarOpen(false);
                        }}
                        className={`
                            flex items-center gap-3 px-4 py-3 rounded-xl text-left transition-all duration-200
                            ${
                                isActive(item.path)
                                    ? "bg-electricBlue text-white shadow-lg"
                                    : "text-slate-300 hover:bg-white/10 hover:text-white"
                            }  
                        `}
                    >
                        {item.icon}
                        {item.label}
                    </button>
                ))}
            </div>

            {/* Logout */}
            <div className="p-4 border-t border-white/10">
                <button
                    onClick={logout}
                    className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-red-500/15 hover:text-red-400 transition-all"
                >
                    <LogOut size={18} />
                    Logout
                </button>
            </div>

        </div>
    )
}

export default Sidebar;